import { Component, OnInit } from '@angular/core';

import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOption } from '@angular/material/select';
import { MatSelect } from '@angular/material/select';
import { FieldBooksService } from '../../../services/field-books/field-books.service';
import { CommonFunctionsService } from '../../../services/common-functions.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'field-book-numbers',
  imports: [
    MatCardModule,
    FormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatTimepickerModule,
    MatFormFieldModule,
    MatOption,
    MatSelect,
    MatCardModule,
    MatInputModule,
    MatExpansionModule,
    MatProgressSpinnerModule
],
  templateUrl: './field-books.component.html',
  styleUrl: './field-books.component.css'
})
export class FieldBooksComponent implements OnInit {
  loadingForm = false;
  requestSubmitted = false;
  fieldBookNumber: string | null = null;
  form: FormGroup;
  formId: string | null = null;

  constructor(private fb: FormBuilder, private fieldBookService: FieldBooksService, private commonFuncs: CommonFunctionsService, private route: ActivatedRoute, private router: Router ) {}

  ngOnInit(): void {
    const today = new Date();
    this.form = this.fb.group({
      requestorEmail: ['', [Validators.required, Validators.email]],
      officeName: ['', Validators.required],
      dateAssigned: [today, Validators.required]
    });
  }

  getFieldBookNumber(): void {
    this.loadingForm = true;
    if (this.form.invalid) {
      this.loadingForm = false;
      return;
    }

    const officeName = this.commonFuncs.translateOfficeLabel(this.form.value.officeName);
    const requestorEmail = this.form.value.requestorEmail;
    this.fieldBookService.getFieldBookNumber(officeName, requestorEmail).subscribe(
      (response) => {
        this.fieldBookNumber = response.data;
        this.loadingForm = false;
        this.requestSubmitted = true;
      },
      (error) => {
        console.error('Error fetching field book number:', error);
        this.loadingForm = false;
      }
    );
  }

}
